export var shouldDisableSubmitButton = function shouldDisableSubmitButton(formState) {
  var submitting = formState.submitting,
    hasValidationErrors = formState.hasValidationErrors,
    hasSubmitErrors = formState.hasSubmitErrors,
    modifiedSinceLastSubmit = formState.modifiedSinceLastSubmit;
  return submitting || hasValidationErrors || hasSubmitErrors && !modifiedSinceLastSubmit;
};